import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { withTranslation } from "react-i18next";
import DefaultLayout from "ui/layouts/DefaultLayout";
import { withCustomComponent } from "ui/components/withCustomComponent";
import { HomeDashboard } from "ui/_pages/home/HomeDashboard";
import { VirtualDashboard } from "ui/_pages/home/VirtualDashboard";
import { GuestHomePage } from "ui/_pages/home/GuestHomePageBW";
import { VirtualHomePage } from "ui/_pages/home/VirtualHomePage";
import { checkTerms } from "env/checkTerms";
import LoadingLayout from "ui/layouts/LoadingLayout";
import { withRouter } from "next/router";
import { errors } from "../env/utils/errors";

@checkTerms
@withRouter
@withCustomComponent('HomePage')
@withTranslation()
@inject('appStore', 'authStore')
@observer
class HomePage extends Component {
  componentDidMount() {
    const { appStore } = this.props;
    appStore.loadHomePage().catch(() => null);
    this.handleUrlQuery();
  }


  handleUrlQuery() {
    const { appStore, router } = this.props;

    if (router.query.error) {
      appStore.setPopMessage(errors(router.query.error));
    }
  }
  render() {
    const { t, appStore, authStore, componentName } = this.props;
    const { virtualDashboard, business, configuration } = appStore;
    const { isLoggedIn } = authStore;

    const isVirtualDashboard =
      configuration['PublicWebSite.Home.UseCommunityDashboard'] == 'true' ||
      virtualDashboard;

    //This just checks we have actually received data from the home page.
    if (!appStore?.homePage?.Gallery) return <LoadingLayout />;

    return (
      <DefaultLayout title={t('Home - My Account - Bruntwood')}>
        <main
          data-component-name={componentName}
          className={`content ${
            isLoggedIn ? 'content--dashboard' : 'content--home'
          }`}
          role="main"
        >
          {isLoggedIn && (
            <>{isVirtualDashboard ? <VirtualDashboard /> : <HomeDashboard />}</>
          )}
          {!isLoggedIn && (
            <>{isVirtualDashboard ? <VirtualHomePage /> : <GuestHomePage />}</>
          )}
        </main>
      </DefaultLayout>
    );
  }
}

export default HomePage;
